import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [CommonModule, DividerModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent implements OnInit {
  checkoutType: boolean | null = null;

  constructor(private router: Router) {}
  ngOnInit(): void {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.checkoutType = navigation.extras.state['checkoutType'];
    }
  }


}
